/**
 * Project : workspace
 * File    : InvoiceItemCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.invoice.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import appConfig.AppConfig
import com.parmartechnologies.core.feature.sale.model.Sale
import theme.ThemeColor

@Composable
/**
 * Executes the invoice item card operation.
 *
 * @receiver TODO
 * @param sale The sale.
 * @return Unit – no return value.
 */
fun InvoiceItemCard(sale: Sale) {
    Column(modifier = Modifier.height(80.dp).padding(start = 8.dp, end = 8.dp).fillMaxWidth()) {
        Row(
            modifier = Modifier
                .background(color = ThemeColor.shared().White)
                .fillMaxHeight()
                .fillMaxWidth().weight(0.5f)
                .padding(start = 8.dp, top = 4.dp, end = 8.dp),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text(
                text = sale.ProductName,
                modifier = Modifier.fillMaxWidth(.45F),
                fontWeight = FontWeight(500),
                fontSize = 12.sp,
                textAlign = TextAlign.Left,
            )
            Text(
                text = "${AppConfig.shared().currencySymbol} ${sale.Tax}",
                fontWeight = FontWeight(500),
                fontSize = 12.sp,
                textAlign = TextAlign.Left,
            )
            Text(
                text = "${AppConfig.shared().currencySymbol} ${sale.Price * sale.Quantity}",
                fontWeight = FontWeight(500),
                fontSize = 12.sp,
                textAlign = TextAlign.Left,
            )
        }
        Row(
            modifier = Modifier
                .background(color = ThemeColor.shared().White)
                .fillMaxHeight()
                .fillMaxWidth().weight(0.5f).padding(start = 8.dp, top = 4.dp, end = 8.dp),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text(
                text = "QTY ${sale.Quantity} x ${AppConfig.shared().currencySymbol} ${sale.Price}",
                modifier = Modifier.fillMaxWidth(.45F),
                fontSize = 12.sp,
                textAlign = TextAlign.Left,
            )
        }
    }

}